import script from "./KanbanEditorDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./KanbanEditorDialog.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__